import React, { Component } from 'react';

import CalloutSection from '../Components/CalloutSection'
import TitleText from '../Components/TitleText'
import ParagraphText from '../Components/ParagraphText'
import Centered from "../Components/Centered";
import TextSection from "../Components/TextSection";
import TopContent from "../Components/TopContent";
import LimitedWidthSection from "../Components/LimitedWidthSection";
import MenuButton from "../Components/MenuButton";
import GradientSection from "../Components/GradientSection";

class Page extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Centered>
              <div className="spacer-40px" />
              <TitleText>About Us</TitleText>
              <div className="spacer-20px" />
            </Centered>
            <TextSection>
              <Centered>
                <div className="spacer-20px" />
                <LimitedWidthSection>
                  <div className="spacer-20px" />
                  <TitleText>Mission: Make Bitcoin easy.</TitleText>
                  <div className="spacer-20px" />

                  <ParagraphText>
                    Biterica makes Bitcoin more accessible through easy to use interfaces.
                  </ParagraphText>
                  <div className="spacer-40px" />

                  <TitleText>Our Story</TitleText>
                  <div className="spacer-20px" />
                  <ParagraphText>
                    Biterica was started when founder Raz’s grandmother send a small gift with instructions to start a bank account for his daughter.  Raz found that monthly banking fees would consume the gift in 10 months.  Instead of storing dollars in a bank, Raz decided to start a Bitcoin account for his daughter.
                  </ParagraphText>
                  <div className="spacer-20px" />
                  <ParagraphText>
                    Raz found that gifting Bitcoin was unnecessarily complex so he set out to build a company to make gifting as simple and pleasant as possible.   One of the best way to teach others about Bitcoin is by gifting them a taste.
                  </ParagraphText>

                  <div className="spacer-80px"/>
                </LimitedWidthSection>
              </Centered>
            </TextSection>

            <GradientSection>
              <div className="spacer-20px" />
              <Centered>
                <MenuButton primary="true" to={'/recipient'}>Send Coins</MenuButton>
              </Centered>
              <div className="spacer-20px" />
            </GradientSection>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/Pages/AboutPage.js